import api from './client';

export const giftsApi = {
  list: () => api.get('/gifts'),
  create: (data: any) => api.post('/gifts', data),
  delete: (id: string) => api.delete(`/gifts/${id}`),
  creditLedger: (memberId: string) => api.get(`/gifts/credit-ledger/${memberId}`),
  sunsetAnalysis: (memberId: string) => api.get(`/gifts/sunset/${memberId}`),
  summary: () => api.get('/gifts/summary/overview'),
};
